import { ICreateContratoArquivoUseCase } from "../../../presentation/useCases/create/create_contrato_arquivo_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


export class CreateContratoArquivoUseCase implements ICreateContratoArquivoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createContratoArquivo(
    IdContrato: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
    Obsoleto: number | null,
    DataVencimento: Date | null,
  ): Promise<void> {
    await this.repository.createContratoArquivo(
      IdContrato,
      Descricao,
      Nome,
      Arquivo,
      Obsoleto,
      DataVencimento,
    );
  }
}
